import { render } from "./PremiumCollectionsReports.vue?vue&type=template&id=795907af&scoped=true"
import script from "./PremiumCollectionsReports.vue?vue&type=script&lang=js"
export * from "./PremiumCollectionsReports.vue?vue&type=script&lang=js"

import "./PremiumCollectionsReports.vue?vue&type=style&index=0&id=795907af&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-795907af"]])

export default __exports__